import { z } from 'zod';
import { currencyCodeSchema, isoDateSchema } from './common';

export const exchangeRateQuerySchema = z.object({
  from: currencyCodeSchema.optional(),
  to: currencyCodeSchema.optional(),
  date: isoDateSchema.optional(),
});
export type ExchangeRateQuery = z.infer<typeof exchangeRateQuerySchema>;

export const syncExchangeRatesSchema = z.object({
  date: isoDateSchema.optional(),
  base: currencyCodeSchema.optional(),
});
export type SyncExchangeRatesInput = z.infer<typeof syncExchangeRatesSchema>;
